import {
    GETEVENTS_FETCH_DATA_SUCCESS,
    GETEVENTS_HAVE_ERROR,
    GETEVENTS_ARE_LOADING,
  } from "../actionType";
  import HttpService from "../../utils/httpService";
  import { Get } from "../../services/api.service";
  
  // Action creator function to handle different types of home primary actions
  export function getEventAction(action, payload) {
    // console.log('getEventAction called with:', action, payload);
    switch (action) {
      case GETEVENTS_HAVE_ERROR:
        return {
          type: action,
          hasError: payload,
        };
  
      case GETEVENTS_ARE_LOADING:
        return {
          type: action,
          isLoading: payload,
        };
  
      case GETEVENTS_FETCH_DATA_SUCCESS:
        return {
          type: action,
          event: payload,
        };
  
      default:
        return;
    }
  }
  
  // Async action creator function to fetch home primary data
  export function getEventsFetchData() {
    // console.log('getEventsFetchData called');
    return (dispatch) => {
      try {
        // Dispatch action indicating data is loading
        dispatch(getEventAction(GETEVENTS_ARE_LOADING, true));
        // console.log('Loading action dispatched');
  
        // Check if event data is available in local storage
        const cachedData = localStorage.getItem("SandeshEvents");
        if (cachedData) {
          // console.log('Found data in localStorage');
          try {
            const parsedData = JSON.parse(cachedData);
            // If available, dispatch action with data from local storage
            dispatch(getEventAction(GETEVENTS_FETCH_DATA_SUCCESS, parsedData));
          } catch (e) {
            console.error('Error parsing cached data:', e);
            localStorage.removeItem("SandeshEvents");
          }
        }
  
        // Fetch event data using GET request
        console.log('Making API call to:', HttpService.event);
        return new Promise((resolve, reject) => {
          Get(HttpService.event)
            .then((result) => {
              // console.log('API call successful:', result);
              if (result && result) {
                // Store fetched data in local storage
                localStorage.setItem("SandeshEvents", JSON.stringify(result));
                // Dispatch action with fetched event data
                dispatch(getEventAction(GETEVENTS_FETCH_DATA_SUCCESS, result));
                resolve(result);
              } else {
                console.error('Invalid response format:', result);
                dispatch(getEventAction(GETEVENTS_HAVE_ERROR, 'Invalid response format'));
                // reject(new Error('Invalid response format'));
              }
            })
            .catch((error) => {
              console.error('API call failed:', error);
              dispatch(getEventAction(GETEVENTS_HAVE_ERROR, error.message));
              reject(error);
            });
        });
      } catch (error) {
        console.error('Error in getEventsFetchData:', error);
        // Dispatch action if there's an error in fetching data
        dispatch(getEventAction(GETEVENTS_HAVE_ERROR, error.message));
      }
    };
  }
  